module.exports = __webpack_public_path__ + "static/traditions-logo-90d2db45c0b44b85c1707b5b5b2a9f5a.svg";